export const getFlatlistFormat = holidayObj => {
    return Object.keys(holidayObj).reduce((accumulator, current, index) => {
        const holidayArray = holidayObj[current];
        const obj = { key: current, value: holidayArray };
        accumulator.push(obj);
        return accumulator;
    }, []);
};
